<div class="coming-soon" [ngClass]="[isVisible ? 'visible' : 'hidden', 'triangle-' + trianglePosition]">
    @if (trianglePosition !== 'bottom') {
    <div class="coming-soon-triangle" [ngClass]="trianglePosition" [style.--triangle-offset.px]="triangleOffset"></div>
    }
    <div class="coming-soon-box">
        <img [src]="'svg/flame.svg' | assetVersion" alt="">
        <div>Coming Soon</div>
    </div>
    @if (trianglePosition === 'bottom') {
    <div class="coming-soon-triangle" [ngClass]="trianglePosition" [style.--triangle-offset.px]="triangleOffset"></div>
    }
</div>